import { styled } from '@linaria/react';
import { layout, space } from '../../theme/tokens';

export const CardGrid = styled.div<{ $columns?: number; $mobileColumns?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $mobileColumns }) => $mobileColumns ?? 1}, 1fr);
  gap: ${space[5]};
  margin-bottom: ${space[10]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: repeat(${({ $columns }) => $columns ?? 2}, 1fr);
  }
`;
